import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslate, FormGroupContextProvider, Loading } from 'react-admin';
import { useAuthorizedChildren } from '../useAuthorizedChildren';
/**
 * Section of a form to be used as child of a `<LongForm>`.
 *
 * Renders a section title, then its children inside a MUI `<Stack>`,
 * and finally an MUI `<Divider>`.
 *
 * Requires a `label` prop and `children`.
 *
 * @example
 * import { TextInput } from 'react-admin';
 * import { LongFormSection } from '@react-admin/ra-form-layout';
 *
 * const IdentitySection = () => (
 *     <LongFormSection label="Identity">
 *         <TextInput source="first_name" />
 *     </LongFormSection>
 * );
 */
export var LongFormSection = React.forwardRef(function LongFormSection(_a, ref) {
    var _b = _a.authorizationError, authorizationError = _b === void 0 ? null : _b, children = _a.children, enableAccessControl = _a.enableAccessControl, label = _a.label, _c = _a.loading, loading = _c === void 0 ? DefaultLoading : _c, sx = _a.sx;
    var translate = useTranslate();
    var _d = useAuthorizedChildren({
        children: children,
        action: 'write',
        enabled: enableAccessControl,
    }), authorizedChildren = _d.authorizedChildren, isPending = _d.isPending, error = _d.error;
    return (_jsx(Root, { ref: ref, sx: sx, children: error ? (authorizationError) : enableAccessControl && isPending ? (loading) : (_jsxs(FormGroupContextProvider, { name: label, children: [_jsx(Typography, { variant: "h4", gutterBottom: true, children: translate(label, { _: label }) }), _jsx(Stack, { className: RaLongFormSection.stack, children: authorizedChildren }), _jsx(Divider, { sx: { mb: 4 } })] })) }));
});
var DefaultLoading = _jsx(Loading, {});
var PREFIX = 'RaLongFormSection';
export var RaLongFormSection = {
    stack: "".concat(PREFIX, "-stack"),
};
var Root = styled('section', {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%'
        },
        _b["& .".concat(RaLongFormSection.stack)] = {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        _b);
});
